module.exports = __webpack_public_path__ + "static/img/cont35 (8).7db8e72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (8).jpg
// module id = B5cB
// module chunks = 0